import { render, staticRenderFns } from "./ClientQuote.vue?vue&type=template&id=6364a73a&scoped=true&"
import script from "./ClientQuote.vue?vue&type=script&lang=js&"
export * from "./ClientQuote.vue?vue&type=script&lang=js&"
import style0 from "./ClientQuote.vue?vue&type=style&index=0&id=6364a73a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6364a73a",
  null
  
)

export default component.exports